import { Vue, Component, Prop } from 'vue-property-decorator';
import { VersionValidatorItem } from 'store';

@Component
export default class VersionValidator extends Vue {
	@Prop({
		default: false
	})
	isAvailable!: boolean;

	@Prop({
		default() {
			return {
				versionFrom: null,
				versionTo: null
			};
		}
	})
	versionInfo!: VersionValidatorItem;

	@Prop({
		default: true
	})
	showLabel!: boolean;
}
